import api from '../../lib/api';
import { CONFIG } from '../../meta/types/config';
import { ResourceFetch } from '../../meta/types/api';

const TPDI_QUOTA_RESOURCE_BASE_PATH = `${CONFIG.tpdiServiceBasePath}/api/v1/dataimport`;

const { GET } = api;

export type TpdiQuotaResponse = {
  data: { collectionId: string; id: string; quotaSqkm: number; quotaUsed: number }[];
};

export interface TpdiResource {
  getQuota: ResourceFetch<TpdiQuotaResponse>;
  getUserIdQuota: ResourceFetch<TpdiQuotaResponse, { id: string }>;
}

const TpdiResource: TpdiResource = {
  getQuota: GET(`${TPDI_QUOTA_RESOURCE_BASE_PATH}/quotas`),
  getUserIdQuota: GET(`${TPDI_QUOTA_RESOURCE_BASE_PATH}/quotas?userId=:id`),
};

export default TpdiResource;
